function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 101.67,
  cy: 21.27,
  r: 12.18,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106.29 20.07a.9.9 0 01.65.25.86.86 0 01.26.63.84.84 0 01-.26.64.89.89 0 01-.65.25h-4.06v4.06a.89.89 0 01-.25.65.82.82 0 01-.63.26.84.84 0 01-.64-.26.89.89 0 01-.25-.65v-4.06H96.4a.88.88 0 01-.65-.26.89.89 0 010-1.26.89.89 0 01.65-.25h4.06V16a.9.9 0 01.25-.65.84.84 0 01.64-.26.86.86 0 01.63.26.89.89 0 01.25.65v4.06z",
  fill: "#ff6231"
});

var SvgIc12 = function SvgIc12(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, React.createElement("text", {
    transform: "translate(40 76)",
    style: {
      isolation: "isolate"
    },
    fontSize: 40,
    fill: "#ff6231",
    fontFamily: "Nunito-Regular,Nunito"
  }, "12"), _ref5, _ref6);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzAgMTMwIj48dGl0bGU+aWMtMTI8L3RpdGxlPjxwYXRoIGQ9Ik0wLTJIMTMwVjEyOEgwWiIgc3R5bGU9ImZpbGw6bm9uZSIvPjxjaXJjbGUgaWQ9ImIiIGN4PSI2NSIgY3k9IjYzIiByPSI1NiIvPjxjaXJjbGUgaWQ9ImItMiIgZGF0YS1uYW1lPSJiIiBjeD0iNjUiIGN5PSI2MyIgcj0iNTYiIHN0eWxlPSJmaWxsOiNmZmY7c3Ryb2tlOiMxMjEyM2I7c3Ryb2tlLXdpZHRoOjJweCIvPjxwYXRoIGQ9Ik0yOSwyN2g3MlY5OUgyOVoiIHN0eWxlPSJmaWxsOm5vbmUiLz48ZyBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiPjx0ZXh0IHRyYW5zZm9ybT0idHJhbnNsYXRlKDQwIDc2KSIgc3R5bGU9Imlzb2xhdGlvbjppc29sYXRlO2ZvbnQtc2l6ZTo0MHB4O2ZpbGw6I2ZmNjIzMTtmb250LWZhbWlseTpOdW5pdG8tUmVndWxhciwgTnVuaXRvIj4xMjwvdGV4dD48L2c+PGNpcmNsZSBjeD0iMTAxLjY3IiBjeT0iMjEuMjciIHI9IjEyLjE4IiBzdHlsZT0iZmlsbDojZmZmO3N0cm9rZTojMTIxMjNiO3N0cm9rZS13aWR0aDoycHgiLz48cGF0aCBkPSJNMTA2LjI5LDIwLjA3YS45LjksMCwwLDEsLjY1LjI1Ljg2Ljg2LDAsMCwxLC4yNi42My44NC44NCwwLDAsMS0uMjYuNjQuODkuODksMCwwLDEtLjY1LjI1aC00LjA2VjI1LjlhLjg5Ljg5LDAsMCwxLS4yNS42NS44Mi44MiwwLDAsMS0uNjMuMjYuODQuODQsMCwwLDEtLjY0LS4yNi44OS44OSwwLDAsMS0uMjUtLjY1VjIxLjg0SDk2LjRhLjg4Ljg4LDAsMCwxLS42NS0uMjYuODkuODksMCwwLDEsMC0xLjI2Ljg5Ljg5LDAsMCwxLC42NS0uMjVoNC4wNlYxNmEuOS45LDAsMCwxLC4yNS0uNjUuODQuODQsMCwwLDEsLjY0LS4yNi44Ni44NiwwLDAsMSwuNjMuMjYuODkuODksMCwwLDEsLjI1LjY1djQuMDZaIiBzdHlsZT0iZmlsbDojZmY2MjMxIi8+PC9zdmc+";
export { SvgIc12 as ReactComponent };